export const ELEM_TYPES = {
  PAGE_PARAM: 'pageParam',
  PARAM: 'param',
  FIELD: 'field',
  LIST_FIELD: 'listField',
  TABLE_FIELD: 'tableField',
  SURVEY_LIST: 'SurveyList',
  TYPOGRAPHY: 'Typography',
  RANGE: 'Range',
  IMAGE: 'Image',
  BUTTON: 'Button',
  YOUTUBE: 'YouTube',
  VIMEO: 'Vimeo',
  TAB: 'Tab',
  POWER_TABLE_WIDGET: 'PowerTableWidget',
  TABLE_WIDGET: 'tableWidget',
  STRIP: 'Strip',
  ADDRESS_FINDER: 'AddressFinder',
  EXTERNAL_LOOKUP: 'ExternalLookup',
  RANKING: 'Ranking',
  CES: 'CES',
  TEXT_COUNTER: 'TextCounter',
  TEXT_REVIEW: 'TextReview',

  // Form Fields
  FORM_FIELD: 'FormField',
  RADIO: 'radio',
  SELECT: 'select',
  BUTTONGROUP: 'buttongroup',
  MULTISELECT: 'multiSelect',
  CURRENCY: 'currency',
  LOOKUP: 'lookup',
  FILE_UPLOAD: 'fileupload',
  SWITCH: 'switch',
  TEXT: 'text',
  PHONE: 'phone',
  NUMBER: 'number',
  DATE: 'date',
  TIME: 'time',
  DATETIME: 'datetime',
  DATE_RANGE: 'daterange',
  CHECKBOX: 'checkbox',
  RICH_TEXTAREA: 'richtextarea',
  SIGNATURE: 'signature',
  SLIDER: 'slider',
  TEXTAREA: 'textarea',
  // TODO: https://titan-scrum.atlassian.net/browse/FT-46 - add the rest of fields
}
